import { TableCell, TableHeader } from 'redesign';
import { Column } from 'react-table';
import { Tooltip, Typography } from '@mui/material';
import { DateTimeCell } from 'shared/components/planner/common/utils';
import { useTranslation } from 'react-i18next';
import {
  PreferredWorkerCellProp,
  PreferredWorkerColumnDefinition,
} from './preferred-worker-table.types';
import { useGetShiftDetailsColumnDefinitionBase } from '../../shared/columns/use-get-shift-details-column-definition-base';

export const useGetPreferredWorkersColumnDefinition: () => Column<PreferredWorkerColumnDefinition>[] =
  () => {
    const { t } = useTranslation('web-common');
    const flexWorkerFullName: Column<PreferredWorkerColumnDefinition> = {
      Header: () => (
        <TableHeader>{t('table_headers.flexworker', { ns: 'web-common' })}</TableHeader>
      ),
      accessor: 'flexWorkerFullName',
      Cell: FlexWorkerCell,
    };

    const dateTime: Column<PreferredWorkerColumnDefinition> = {
      Header: () => (
        <TableHeader>{t('table_headers.condition_date_time', { ns: 'web-common' })}</TableHeader>
      ),
      accessor: 'dateTime',
      Cell: DateTimeCell,
    };
    const status: Column<PreferredWorkerColumnDefinition> = {
      Header: () => <TableHeader>{t('table_headers.status', { ns: 'web-common' })}</TableHeader>,
      accessor: 'status',
      Cell: ({ value }: PreferredWorkerCellProp<'status'>) => (
        <TableCell>
          <Typography noWrap>{value}</Typography>
        </TableCell>
      ),
    };
    const [flexWorkerImage] = useGetShiftDetailsColumnDefinitionBase();
    return [flexWorkerImage, flexWorkerFullName, dateTime, status];
  };

const FlexWorkerCell = ({ value }: PreferredWorkerCellProp<'flexWorkerFullName'>) => {
  return (
    <TableCell>
      <Tooltip title={value}>
        <Typography noWrap>{value}</Typography>
      </Tooltip>
    </TableCell>
  );
};
